// extracted by mini-css-extract-plugin
module.exports = {"outerDiv":"OuterDiv_outerDiv__YE4GA"};